import { render, staticRenderFns } from "./user_order.vue?vue&type=template&id=27ab7cbe&scoped=true"
import script from "./user_order.vue?vue&type=script&lang=js"
export * from "./user_order.vue?vue&type=script&lang=js"
import style0 from "./user_order.vue?vue&type=style&index=0&id=27ab7cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ab7cbe",
  null
  
)

export default component.exports